/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `HUBSPOT` - Hubspot
* `WHATSAPP` - WhatsApp
* `GROUND_CONTROL` - Ground control
* `SELF_SERVE` - Self serve
 */
export type TradeSignalSourceType = typeof TradeSignalSourceType[keyof typeof TradeSignalSourceType];


export const TradeSignalSourceType = {
  HUBSPOT: 'HUBSPOT',
  WHATSAPP: 'WHATSAPP',
  GROUND_CONTROL: 'GROUND_CONTROL',
  SELF_SERVE: 'SELF_SERVE',
} as const;
